import {
  GUIDE_BETA_DISCLAIMER_TEXT_KEY,
  isGuideBeta,
  resolveGuideBetaDisclaimer,
} from "../../../../shared/utils/guideBeta";

// Disclaimer de Beta. VIVA-1248, criterios de VIVA-1165.
//
// Se coloca en los dos puntos que pide la historia —la ficha, antes del boton de
// compra, y el checkout, antes de confirmar— y decide por si mismo si aparece.
// Quien lo usa no tiene que preguntar nada.
//
// No pinta nada si la guia no esta en Beta (criterio negativo de VIVA-1165: una
// guia sin estado Beta no muestra el disclaimer en ninguna de las dos
// pantallas).
//
// El texto sale del esquema remoto, que ya llega en el idioma de la interfaz.
// Mientras la clave no este publicada se usa el texto PROVISIONAL de
// `guideBeta.js`, en el idioma que indique `isEnglish` (decision del
// 22/09/2026; no esta aprobado por legal, VIVA-1220).
//
// `textKey` existe para poder probarlo con una clave concreta mientras la real
// no este publicada; en la aplicacion nadie la pasa.
const GuideBetaDisclaimer = ({
  guide,
  texts,
  textKey = GUIDE_BETA_DISCLAIMER_TEXT_KEY,
  isEnglish = false,
  className = "",
}) => {
  if (!isGuideBeta(guide)) return null;

  const disclaimer = resolveGuideBetaDisclaimer(texts, textKey, isEnglish);
  if (!disclaimer) return null;

  return (
    <p className={`g2-beta-disclaimer ${className}`.trim()} role="note">
      {disclaimer}
    </p>
  );
};

export default GuideBetaDisclaimer;
